<template>
  <div>
    <ux-image-upload :tag="currentTag"></ux-image-upload>

    <ux-tag-nav
      :tags="tagsSorted"
      :clear="true"
      @tagupdate="updateTag"
      @onclear="clearFilter"
      :selected="currentTag"
    ></ux-tag-nav>
    <ux-image-grid :items="uploads" keyTitle="name"></ux-image-grid>
  </div>
</template>

<script>
import UxTagNav from "./UxTagNav";
import UxImageGrid from "./UxImageGrid";
import UxImageUpload from "./UxImageUpload";
export default {
  components: { UxTagNav, UxImageGrid, UxImageUpload },
  data() {
    return {
      title: "Work Samples",
      date: 1551942596698,
      currentTag: ""
    };
  },
  created() {},
  methods: {
    updateTag(tag) {
      this.currentTag = tag;
    },
    clearFilter() {
      this.currentTag = "";
    }
  },

  filters: {
    title(val) {
      if (!val) return "";
      val = val.toString();
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
  },
  computed: {
    uploads() {
      return this.$store.getters.uploads.filter(el => {
        return el.tags.includes(this.currentTag);
      });
    },
    tags() {
      return this.$store.getters.tags;
    },
    tagsSorted() {
      return [...this.tags].sort();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-heading {
  margin-bottom: 30px;
}
</style>
